<template>
  <div style="margin-top: 10px;">
    <div style="margin-bottom: 5px;">
      <el-button type="primary" size="small" @click="goUploadList">上传</el-button>
      <el-button type="primary" size="small" @click="edit">编辑</el-button>
    </div>
    <el-table
      stripe
      :header-cell-style="{backgroundColor: '#F4F8FB'}"
      :data="tableData"
      :height="tableHeight"
      v-if="tableHeight"
      v-loading="loading"
      border
      ref="elTable"
      @selection-change="selectionChange"
      :header-cell-class-name="cellClass"
      :expand-row-keys="rowKeys"
      :row-key="setRowKey"
    >
      <el-table-column type="selection" :selectable="handleSelectable"></el-table-column>
      <el-table-column label="文件名" prop="fileName" show-overflow-tooltip></el-table-column>
      <el-table-column label="关联SPU数量" prop="spuNum" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="80px">
        <template slot-scope="scope">
          <el-button type="text" @click="previewPdf(scope.row)">打开</el-button>
        </template>
      </el-table-column>
      <el-table-column type="expand" width="80px">
        <template slot-scope="props">
          <el-table border stripe :data="props.row.spuInfo">
            <el-table-column label="图片" width="80px">
              <template slot-scope="scope" v-if="showDetailBtn(scope.row)">
                <el-link :underline="false" type="primary" @click="showDialog(scope.row, 0)">查看</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="spuCode" label="SPU编码" show-overflow-tooltip></el-table-column>
            <el-table-column prop="spuName" label="SPU名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="spuCategory" label="SPU品类" width="80px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="spuTaskName" label="SPU进度" width="80px" show-overflow-tooltip></el-table-column>
            <el-table-column prop="instruction" label="更新说明" show-overflow-tooltip></el-table-column>
            <el-table-column prop="creationDate" label="上传时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createdBy" label="操作人" width="80px"></el-table-column>
          </el-table>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right; margin-top: 10px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationOpt.pageNum"
        :page-sizes="paginationOpt.pageSizes"
        :page-size="paginationOpt.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="paginationOpt.total"
      ></el-pagination>
    </div>
    <!-- 视频、图片查看 -->
    <pic-video v-model="picVideoVisible" :data="rowData" v-if="picVideoVisible"></pic-video>
    <!-- 导入导出 -->
    <import-export ref="importExport" @onsuccess="init"></import-export>
    <!-- 编辑 -->
    <edit
      :visible.sync="editVisible"
      :data="selectData[0]"
      :dataType="dataType"
      @success="init"
      @onRemove="handleRemove"
      v-if="editVisible"
    ></edit>
  </div>
</template>

<script>
import picVideoMxin from "./pic&video.mixin";
import importExportMxin from "./import&export.mixin";
import pagePathMixin from '@/utils/page-path-mixin'
import edit from "./edit";
export default {
  mixins: [picVideoMxin, importExportMxin, pagePathMixin],
  components: { edit },
  props: ["tableHeight", "dataType"],
  data() {
    return {
      rowKeys: [],
      loading: false,
      formData: {},
      tableData: [],
      paginationOpt: {
        pageSizes: [30, 60, 90],
        pageSize: 30,
        pageNum: 1,
        total: 0
      },
      selectData: [],
      editVisible: false
    };
  },
  computed: {
    // 公共页面 1 bom表， 2信息表
    pageType() {
      if (this.dataType == 1) {
        return "bom";
      } else if (this.dataType == 2) {
        return "message";
      }
    }
  },
  watch: {
    dataType(val) {
      this.init();
    }
  },
  mounted() {
    this.$bus.$off("closeAll").$on("closeAll", _ => {
      this.editVisible = false;
      this.init();
    });
    this.init();
    this.rowKeys = [];
  },
  methods: {
    cellClass(row){     
      if (row.columnIndex === 0) {           
      return 'disabledCheck'     
      }
    },
    setRowKey(row) {
      return row.fileId;
    },
    expand(flag) {
      this.rowKeys = flag ? this.tableData.map(item => item.fileId) : [];
    },
    handleSearch(data) {
      this.paginationOpt.pageNum = 1;
      this.formData = data;
      this.init();
    },
    init() {
      this.loading = true;
      let formData = {
        pageSize: this.paginationOpt.pageSize,
        pageNum: this.paginationOpt.pageNum,
        filterData: {
          ...this.formData,
          dataType: this.dataType
        }
      };
      this.$q.newProduct
        .bominfoPage({ data: formData })
        .then(res => {
          this.tableData = res.data.records;
          this.paginationOpt["total"] = res.data.total;

          // 若存在默认勾选的行，贼要在更新数据后，默认勾选上，并展开
          let currentSelect;
          if (this.selectData.length) {
            currentSelect = this.selectData[0].fileId;
          }
          this.$nextTick(_ => {
            if (currentSelect) {
              let currentSelectRow = this.tableData.filter(
                v => v.fileId === currentSelect
              )[0];
              this.$refs["elTable"].toggleRowSelection(currentSelectRow);
              this.$refs["elTable"].toggleRowExpansion(currentSelectRow);
            }
          });
        })
        .finally(_ => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    },
    /**
     * 选择行
     */
    selectionChange(data) {
      this.selectData = data;
    },
    handleSelectable(row, index) {
      // 只能单次选择一个
      if (
        this.selectData.length == 1 &&
        this.selectData[0].fileId !== row.fileId
      ) {
        return false;
      } else {
        return true;
      }
    },
    /**
     * 编辑
     */
    edit() {
      if (!this.selectData.length) {
        this.$message.error("请选择要编辑的数据");
      } else {
        this.editVisible = true;
      }
    },
    /**
     * 下载
     */
    downLoadFile(path, name) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(_ => {
        this.downLoad(path, name);
        loading.close();
      }, 300);
    },
    downLoad(path, name) {
      let url = path;
      let fileName = name;
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = function() {
        if (xhr.status === 200) {
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(xhr.response, fileName);
          } else {
            var link = document.createElement("a");
            var body = document.querySelector("body");

            link.href = window.URL.createObjectURL(xhr.response);
            link.download = fileName;

            // fix Firefox
            link.style.display = "none";
            body.appendChild(link);

            link.click();
            body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          }
        }
      };
      xhr.send();
    },
    /**
     * 编辑弹框spu列表删除成功回调
     */
    handleRemove(data) {
      this.selectData[0].spuInfo = data;
    },
    /**
     * 上传页面跳转
     */
    goUploadList() {
      this.openSubPage({
        path: "/messageSheet",
        query: {
          fileType: this.dataType // 1bom表，2信息表，3说辞表
        }
      });
    },
    /**
     * pdf预览
     */
    previewPdf(row) {
      this.$q.newProduct
        .informationPreview({
          params: {
            fileId: row.fileId
          },
          options: {
            responseType: "blob"
          }
        })
        .then(res => {
          console.log("res===", res);
          if (res.code == 200) {
            let pdfUrl = res.data.filePath;
            this.openSubPage({path:'/previewPdf',query:{pdfUrl}})
            // window.open(res.data.filePath)
          }
        });
    }
  }
};
</script>
<style lang="stylus" scoped>
th div.cell .el-checkbox {
  display: none !important;
}
>>> .el-table .disabledCheck .cell .el-checkbox__inner{ //隐藏全选
    display: none !important; 
}
</style>
